/* eslint-disable react/require-default-props */
import React from 'react';
import { Link } from 'react-router-dom';
import iconConlicitaseg from 'assets/images/panel/conlicitaseg.svg';
import createTrack from 'services/actions/tracker_actions';

export type GuaranteeInsuranceType = 'participacao' | 'execucao';

const TYPE_LABEL: Record<GuaranteeInsuranceType, string> = {
  participacao: 'Participação',
  execucao: 'Execução',
};

interface BiddingGuaranteeInsuranceProps {
  type: GuaranteeInsuranceType;
  biddingId: number;
  showQuoteButton?: boolean;
  buttonOnly?: boolean;
  buttonLabel?: string;
  ariaLabel?: string;
  trackingSource?: string;
}

const BiddingGuaranteeInsurance = (props: BiddingGuaranteeInsuranceProps) => {
  const {
    type,
    biddingId,
    showQuoteButton = true,
    buttonOnly = false,
    buttonLabel = 'Faça sua cotação',
    ariaLabel,
    trackingSource = 'Card da Licitação',
  } = props;

  const quoteButton = (
    <Link
      to={`/conlicitaseg/garantia/nova?bidding_id=${biddingId}&tipo=${type}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn btn-outline-primary${buttonOnly ? '' : ' btn-sm'}`}
      aria-label={ariaLabel}
      onClick={() => {
        createTrack(`ConlicitaSeg - Clicou em preenchimento automático de ${TYPE_LABEL[type]}`, {
          fonte: trackingSource,
        });
      }}
    >
      {buttonLabel}
    </Link>
  );

  if (buttonOnly) return showQuoteButton ? quoteButton : null;

  return (
    <div className="bidding-guarantee-insurance border-top border-bottom py-3 my-3 d-print-none">
      <div className="bidding-info-title mb-2">Seguro Garantia:</div>
      <div className="d-flex justify-content-start align-items-center flex-wrap">
        <div className="d-flex align-items-center mr-3">
          <img
            src={iconConlicitaseg}
            alt="Ícone Seguro Garantia"
            width="24"
            height="24"
            className="mr-2"
          />
          <span className="mt-2">{`Essa licitação exige Seguro Garantia de ${TYPE_LABEL[type]}`}</span>
        </div>
        {showQuoteButton && quoteButton}
      </div>
    </div>
  );
};

export default BiddingGuaranteeInsurance;
